(function () {
  let scheduled = false;

  function scheduleInit() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      initCustomFilters();
    });
  }

  function initCustomFilters() {
    const facetForms = document.querySelectorAll('form.face-form, form[is="facet-form"]');

    facetForms.forEach(function (facetForm) {
      const filters = facetForm.querySelectorAll('details.facet-accordion-details');

      filters.forEach(function (filter) {
        hideSingleOptionFilter(filter);
        setupScrollableFilter(filter);
      });
    });
  }

  function isPriceFilter(filter) {
    const title = filter.querySelector('summary .h6, summary span');
    const titleText = title ? normalizeText(title.textContent) : '';
    const dataIndex = normalizeText(filter.getAttribute('data-index') || '');

    return (
      titleText.includes('preco') ||
      titleText.includes('price') ||
      dataIndex.includes('price') ||
      dataIndex.includes('preco') ||
      dataIndex.includes('price_range')
    );
  }

  function hideSingleOptionFilter(filter) {
    /* Não oculta preço */
    if (isPriceFilter(filter)) {
      filter.classList.remove('custom-hide-single-filter');
      filter.hidden = false;
      return;
    }

    const options = getFilterOptions(filter);
    const checkedOption = filter.querySelector('input[type="checkbox"]:checked');

    /* Esconde filtros com 1 opção, exceto se estiver marcada */
    if (options.length <= 1 && !checkedOption) {
      filter.classList.add('custom-hide-single-filter');
      filter.hidden = true;
    } else {
      filter.classList.remove('custom-hide-single-filter');
      filter.hidden = false;
    }
  }

  function setupScrollableFilter(filter) {
    /* Não aplica busca/rolagem no preço */
    if (isPriceFilter(filter)) return;

    const content = filter.querySelector('.accordion-details__content');
    const list = filter.querySelector('.accordion-details__content > ul');
    const options = getFilterOptions(filter);

    if (!content || !list || options.length <= 5) return;

    filter.classList.add('custom-scrollable-facet');
    list.classList.add('custom-filter-scroll-list');

    /* Libera itens do Mostrar Mais */
    list.querySelectorAll('li.show-more-item.hidden').forEach(function (item) {
      item.classList.remove('hidden');
    });

    /* Esconde botão Mostrar Mais */
    content.querySelectorAll('show-more-button, .button-show-more').forEach(function (button) {
      button.style.display = 'none';
    });

    /* Evita duplicar busca */
    if (content.querySelector('.custom-filter-search')) return;

    const searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.className = 'custom-filter-search';
    searchInput.placeholder = 'Buscar neste filtro';
    searchInput.autocomplete = 'off';

    content.insertBefore(searchInput, list);
  }

  function getFilterOptions(filter) {
    return Array.from(
      filter.querySelectorAll('.accordion-details__content > ul > li')
    ).filter(function (item) {
      return item.querySelector('input[type="checkbox"]');
    });
  }

  function filterFacet(searchInput) {
    const filter = searchInput.closest('details.facet-accordion-details');
    if (!filter) return;

    const list = filter.querySelector('.accordion-details__content > ul');
    if (!list) return;

    const searchValue = normalizeText(searchInput.value);

    list.querySelectorAll('li').forEach(function (item) {
      const label = item.querySelector('.reversed-link__text');
      const text = normalizeText(label ? label.textContent : item.textContent);

      item.classList.toggle(
        'custom-filter-item-hidden',
        searchValue && !text.includes(searchValue)
      );
    });
  }

  function normalizeText(text) {
    return String(text)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('.custom-filter-search')) {
      filterFacet(event.target);
    }
  });

  document.addEventListener('DOMContentLoaded', scheduleInit);
  document.addEventListener('shopify:section:load', scheduleInit);

  document.addEventListener('click', function () {
    setTimeout(scheduleInit, 300);
  });

  document.addEventListener('toggle', function (event) {
    if (event.target.matches('details.facet-accordion-details')) {
      setTimeout(scheduleInit, 100);
    }
  }, true);

  const observer = new MutationObserver(scheduleInit);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(scheduleInit, 500);
  setTimeout(scheduleInit, 1500);
  setTimeout(scheduleInit, 3000);
})();